/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import {
  REQUEST_USERS,
  REQUEST_USER,
  REQUEST_USER_PROPERTY_NAMES,
  REQUEST_COUNTRIES,
  REQUEST_COMPANIES,
  REQUEST_USER_FILTER,
  UPDATE_USER_FILTERS,
  REQUEST_USER_FILTER_RESET,
  GET_PERMISSIONS,
  UPDATE_PERMISSIONS,
  REQUEST_WEBSITE_USER_FILTER,
  REQUEST_WEBSITE_USERS,
  REQUEST_WEBSITE_USER,
  REQUEST_HOME_COMPANY_USERS,
  REQUEST_USER_HISTORY,
  UPDATE_USER_HISTORY_SEARCH_STRING,
  UPDATE_USER_HISTORY_FILTER,
} from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { parseStoreUser } from './helpers';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  properties: [],
  sortType: null,
  order: null,
};

export const initialState = {
  //specific users fetched by id
  fetchedUsers: {},
  permissions: [],
  //users fetched per page
  users: [],
  homeUsers: [],
  filter: {
    ...DEFAULT_FILTER,
  },
  usersCount: null,
  propertyNames: null,
  countries: null,
  companies: null,
  paginator: null,
  websiteFilter: {
    searchString: null,
    offset: 0,
  },
  historyLogs: [],
  filterHistoryLogs: {
    text: '',
    properties: [],
  },
};

export const userReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action?.id) {
      case REQUEST_USER_HISTORY:
        if (action?.result) {
          draft.historyLogs = action?.result?.items;
        }

        break;
    }
    switch (action.type) {
      case REQUEST_USER_FILTER:
      case UPDATE_USER_FILTERS:
        if ('propertyFilter' in action) {
          if (action.reset == 'website') {
            draft.websiteFilter.mainFilter = null;
          }
          draft.filter.properties = draft.filter.properties
            .map(p => {
              if (p.key == action.propertyFilter?.key) return null;
              if (p.key == action.reset) return null;
              if (action.reset?.indexOf?.(p.key) > -1) {
                return null;
              }

              return p;
            })
            .filter(p => p);

          if (action.propertyFilter) draft.filter.properties.push(action.propertyFilter);
        }

        //clear empty values
        draft.filter.properties = draft.filter.properties.filter(p => p.value.length || p.value.id);

        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
        }
        if (action.name !== 'offset') draft.filter.offset = 0;
        break;
      case REQUEST_USER_FILTER_RESET:
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        draft.websiteFilter.mainFilter = null;
        break;
      case REQUEST_WEBSITE_USER_FILTER:
        if (action.name) {
          draft.websiteFilter[action.name] = action.value;
          //reset offset
          if (action.name !== 'offset') draft.filter.offset = 0;
        }
        break;
      case UPDATE_USER_HISTORY_SEARCH_STRING:
        draft.filterHistoryLogs.text = action?.text;
        break;
      case UPDATE_USER_HISTORY_FILTER:
        draft.filterHistoryLogs.properties = action?.properties;
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_HOME_COMPANY_USERS:
            draft.homeUsers = action.result;
            break;
          case REQUEST_USERS:
            draft.users = action.result.items.map(parseStoreUser);
            draft.paginator = action.result.paginator;
            draft.usersCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_USER:
            try {
              const user = parseStoreUser(action.result);
              draft.fetchedUsers[action.result.id] = user;
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_USER_PROPERTY_NAMES:
            draft.propertyNames = action.result;
            break;
          case REQUEST_COUNTRIES:
            draft.countries = action.result;
            break;
          case REQUEST_COMPANIES:
            draft.companies = action.result.items;
            break;
          case GET_PERMISSIONS:
            draft.permissions = action.result.permissions;
            break;
          case UPDATE_PERMISSIONS:
            draft.updatedUser = action.result;
            break;
          case REQUEST_WEBSITE_USER:
            try {
              draft.websiteUser = parseStoreUser(action.result);
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_WEBSITE_USERS:
            if (!draft.website) draft.website = {};
            draft.website.users = action.result.items.map(parseStoreUser);
            draft.website.paginator = action.result.paginator;
            draft.website.usersCount = action.result.paginator.itemsCount;
            break;
        }
    }
  });
